export default __webpack_public_path__ + "static/media/verify_white.92aebb6e.svg";